export const SET_PROFILE_BIO_DATA = 'SET_PROFILE_BIO_DATA';


export function setProfilProcessBio(profileBio) {
   return {
      type: SET_PROFILE_BIO_DATA ,
      profileBio,
   };
}